// extracted by mini-css-extract-plugin
export default {"container":"notfound_container__plx9k","msg":"notfound_msg__Rm-XG","button":"notfound_button__GOMcw"};